import Base from './base';

class Blog extends Base {
  uploadImage = (data) => this.postRequest('/file/upload', data);

  getAll = (query) => this.getRequest('/blog', query);
  getById = (id) => this.getRequest(`/blog/${id}`);
  create = (data) => this.postRequest('/blog', data);
  update = (id, data) => this.putRequest(`/blog/${id}`, data);
  delete = (id) => this.deleteRequest(`/blog/${id}`);

  publish = (id) => this.postRequest(`/blog/${id}/publish`);
  schedule = (id, publishAt) =>
    this.postRequest(`/blog/${id}/schedule`, null, { publishAt });

  getCategories = () => this.getRequest('/blog/category');
  createCategory = (data) => this.postRequest('/blog/category', data);
  updateCategory = (id, data) =>
    this.putRequest(`/blog/category/${id}`, data);
  deleteCategory = (id) => this.deleteRequest(`/blog/category/${id}`);
}

export default new Blog();
